<template>
  <div class="h-screen flex w-full bg-img">
    <div
      class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-2/2 mx-auto text-center"
    >
      <img src="../../assets/images/pages/apps.png" alt="graphic-apps" class="mx-auto mb-4" />
      <h1 id="clock">{{time}}</h1>
      <h1 class="sm:mx-0 mx-4 sm:mb-12 mb-8 text-5xl d-theme-heading-color">{{appTitle}}</h1>
      <div class="flex">
        <vs-card
          v-for="app in apps"
          :key="app.code"
          class="flex-1 m-2 hover:shadow-outline"
          style="cursor:pointer"
          @mouseover.native="onHover(app.name)"
          @mouseleave.native="onHover('Application Portal')"
          @click.native="linkto(app)"
        >
          <div slot="header">
            <img :src="require(`../../assets/images/apps/${app.image}.png`)" />
          </div>
        </vs-card>
        <vs-card
          v-if="userRole=='admin'"
          class="flex-1 m-2 hover:shadow-outline"
          style="cursor:pointer"
          @mouseover.native="onHover('Administrator')"
          @mouseleave.native="onHover('Application Portal')"
          @click.native="goAdmin"
        >
          <div slot="header">
            <img src="../../assets/images/apps/adminconf.png" />
          </div>
        </vs-card>
      </div>
    </div>
  </div>
</template>

<script>
import bcrypt from "bcryptjs";
import axios from "./axios_conf";

export default {
  data() {
    return {
      token: localStorage.getItem("token"),
      userRole: localStorage.getItem("userRole"),
      apps: [],
      time: null,
      urltoken: null,
      freshtoken: null,
      ntoken: null,
      hashtoken: null,
      tksplit: [],
      tresult: null,
      appTitle: "Application Portal"
    };
  },
  methods: {
    goAdmin() {
      // alert("Admin");
      this.$router.replace("/");
    },
    onHover(data) {
      this.appTitle = data;
    },
    timeUpdate() {
      setInterval(() => {
        let cd = new Date();
        this.time =
          zeroPadding(cd.getHours(), 2) +
          ":" +
          zeroPadding(cd.getMinutes(), 2) +
          ":" +
          zeroPadding(cd.getSeconds(), 2);
      }, 1000);

      function zeroPadding(num, digit) {
        var zero = "";
        for (var i = 0; i < digit; i++) {
          zero += "0";
        }
        return (zero + num).slice(-digit);
      }
    },
    linkto(app) {
      // console.log(link);
      let appurl = app.appurl + ":" + app.appport;
      let appdb = app.dburl + ":" + app.dbport;
      // let dburl = app.dburl + ":" + app.dbport;
      // localStorage.setItem(app.appgroups_code, dburl);
      localStorage.removeItem("token");
      localStorage.removeItem("authurl");
      localStorage.removeItem("userRole");
      window.location.replace(
        appurl +
          "/pages/precheck/" +
          this.urltoken +
          "|" +
          app.code +
          "/" +
          this.$store.state.dburl +
          "/" +
          appdb
      );
    },
    reToken() {
      // let str1 = "12-33455/12345-5";
      let str1 = bcrypt.hashSync(this.token, 8);
      let str = str1.replace(/\//gi, "").replace(/-/gi, "");
      // this.ntoken = str;
      this.hashtoken = str;

      let stlen = str.length;
      let dg1, dg2, dg3, dg4, dg5, st1, st2, st3, st4, st5, st6, fstr;

      st1 = str.substr(0, 5);
      st2 = str.substr(6, 5);
      st3 = str.substr(11, 5);
      st4 = str.substr(16, 5);
      st5 = str.substr(21, 5);
      st6 = str.substr(26, stlen);

      dg1 = this.token.substring(0, 1);
      dg2 = this.token.substring(2, 3);
      dg3 = this.token.substring(4, 5);
      dg4 = this.token.substring(6, 7);
      dg5 = this.token.substring(8, 9);

      fstr = st1 + dg1 + st2 + dg2 + st3 + dg3 + st4 + dg4 + st5 + dg5 + st6;

      this.ntoken = fstr;

      return fstr;
    },
    getNewToken() {
      let ftoken, flen, urtoken, urlen;

      ftoken = this.hashtoken;
      flen = this.token.length;
      urtoken = ftoken + "|" + flen + "|" + this.token;
      urlen = urtoken.length;

      return urlen + "|" + urtoken;
    },
    getApps() {
      // this.ntoken = bcrypt.hashSync(this.token, 8);
      this.freshtoken = this.reToken();
      this.urltoken = this.getNewToken();
      // this.tksplit = this.urltoken.split("-");

      // this.tresult = this.tksplit.length; // 4
      // this.tresult = this.tksplit.length; // 4
      // this.tresult = this.tksplit[0]; // 82
      // this.tresult = this.tksplit[this.tksplit.length - 2]; // 18
      // this.tresult = this.tksplit[0] - this.tksplit[this.tksplit.length - 2]; // 64
      // this.tresult = this.tksplit[1];

      const formData = {
        token: this.token,
        email: this.token,
        freshtoken: this.freshtoken
      };

      axios
        .post("/ApiGetApps", formData)
        .then(res => {
          // console.log(res);
          if (res.data.status == "ok") {
            let arlen = res.data.message.length;
            for (let i = 0; i < arlen; i++) {
              this.apps.push(res.data.message[i]);
            }

            // console.log(this.$store.state.dburl);
          } else {
            alert(res.data.message);
          }
        })
        .catch(err => {
          // console.log(err);
          alert(err);
        });
    }
  },
  created() {
    this.timeUpdate();
    this.getApps();
  },
  mounted() {
    let userRole = localStorage.getItem("userRole");
    this.$acl.change(userRole);
  }
};
</script>

<style scoped>
</style>

